import { render, staticRenderFns } from "./SentenceListAddElementsList.vue?vue&type=template&id=db93572c&"
import script from "./SentenceListAddElementsList.vue?vue&type=script&lang=js&"
export * from "./SentenceListAddElementsList.vue?vue&type=script&lang=js&"
import style0 from "./SentenceListAddElementsList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports